import React from "react";
import { MotifFormField, MotifInput, MotifTextArea } from "@ey-xd/motif-react";
import "./InputBox.scss";
import { getNumbersAndDecimals, ltrimString } from "@/utility/common";
type InputBoxType = {
  id?: string;
  required?: boolean;
  value: string | number;
  isTextArea?: boolean;
  onChange: (e: any) => void;
  placeholder?: string;
  type?: "number" | "text" | "tel" | "email" | "date" | "password" | undefined;
  readonly?: boolean;
  digitAfterDecimal?: number;
  isAmount?: boolean;
  onChangeAmount?: (value: string) => boolean | void;
};

export default function InputBoxNumber({
  id,
  type,
  required = false,
  value,
  isTextArea,
  onChange,
  placeholder,
  readonly,
  digitAfterDecimal,
  isAmount,
  onChangeAmount,
  ...args
}: InputBoxType) {
  value = ltrimString(String(value)) || "";
  const onChangeHandler = (e: React.FormEvent<HTMLInputElement>) => {
    let value = e.currentTarget.value;
    const digitAfterDecimalCurrent = getNumbersAndDecimals(value);
    let number = value?.split(".")[0];
    number = number?.replace(/-/g, "");
    if (number.length >= 9) {
      digitAfterDecimal = 3;
    }
    if (number.length <= 13) {
      if (
        isAmount &&
        digitAfterDecimal &&
        digitAfterDecimalCurrent > digitAfterDecimal
      ) {
        value = value.toString();
        const decimalIndex = value.indexOf(".");
        value = value.toString().slice(0, decimalIndex + digitAfterDecimal + 1);
        if (/^-?\d*\.?\d*$/.test(value)) {
          onChangeAmount && onChangeAmount(value);
          onChange(value);
        }
      } else if (isAmount && !digitAfterDecimal) {
        if (/^-?\d*\.?\d*$/.test(value)) {
          onChangeAmount && onChangeAmount(value);
          onChange(value);
        }
      } else {
        if (/^-?\d*\.?\d*$/.test(value)) {
          onChangeAmount && onChangeAmount(value);
          onChange(value);
        }
      }
    }
  };
  return (
    <>
      <MotifFormField role="group" aria-label={id}>
        {isTextArea ? (
          <MotifTextArea
            {...args}
            id={id}
            value={value}
            maxLength="1000"
            onChange={onChange}
            placeholder={placeholder}
            disabled={readonly}
          />
        ) : (
          <MotifInput
            type={type}
            hideClearButton={true}
            {...args}
            //@ts-ignore
            id={id}
            value={value}
            maxLength="100"
            onChange={onChangeHandler}
            placeholder={placeholder}
            disabled={readonly}
          />
        )}
      </MotifFormField>
    </>
  );
}
